<template>
  <div class="dropdown-wrapper">
    <div class="dropdown-inner-wrapper px-1">
      <v-radio-group v-model="valueComputed">
        <v-row v-for="(user, index) in users" :key="index" class="user-list-item align-center flex-nowrap" :class="{active:user.active}" @click="valueComputed = index">
          <v-col class="col-user-img">
            <img :src="user.imageSrc" v-if="typeof user.imageSrc !== 'undefined'" alt=""/>
            <div v-if="typeof user.imageSrc === 'undefined'" class="default-avatar-background">
              <PersonIcon class="default-avatar"/>
            </div>
          </v-col>
          <v-col class="col-user-name">
            {{ user.name }}
          </v-col>
          <v-col class="col-radio">
            <v-radio :value="index"/>
          </v-col>
          <span class="active-indication" v-if="user.active">{{$t('groupDropdown.activeIndication')}}</span>
        </v-row>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
import {computed} from "@vue/composition-api";
import PersonIcon from "@/components/icons/PersonIcon";

export default {
  name: "GroupDropdown",
  components: {PersonIcon},
  props: {
    value: {
      type: Number,
      default: 0
    },
    users: Array
  },
  setup(props, {emit}) {
    const valueComputed = computed({
      get: () => props.value,
      set: value => {
        emit('input', value)
      }
    })
    return {valueComputed}
  }
}
</script>

<style scoped lang="scss">
.dropdown-wrapper {
  position: relative;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  font-size: 16px;
  line-height: 20px;
  width: 290px;

  // Shadow
  &::before {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    z-index: 1050;
    box-shadow: 0 6px 10px 0 rgba(0,0,0, .75);
    content: '';
    height: 1px;
  }

  .dropdown-inner-wrapper {
    overflow-y: auto;
    max-height: 300px;
  }

  .v-input--selection-controls {
    margin: 0;
    padding: 0;
  }

  .col-user-img {
    padding-right: 8px;
    flex: 0 0 56px;
    width: 56px;
  }

  .col-user-name {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    padding: 16px 0;
    word-break: break-all;
  }

  .col-radio {
    padding: 16px 8px;
    flex-basis: 24px;
    max-width: 40px;
  }
}

.default-avatar-background {
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: map-get($grey, 'lighten-blue-1');
  border-radius: 50%;

  .default-avatar {
    margin: auto;
    height: 50%;
    width: 50%;
  }
}

.user-list-item {
  position: relative;
  border-bottom: 1px solid map-get($grey, 'lighten-3');

  &:last-child {
    border: none;
  }

  &.active {
    background-color: map-get($grey, 'lighten-4');
    order: -1;
  }

  &:hover {
    background-color: rgba($primary, .2);
  }

  .active-indication {
    position: absolute;
    right: 10px;
    top: 2px;
    color: map-get($grey, 'lighten-blue-1');
    font-size: 12px;
    font-weight: 400;
  }

  img {
    border-radius: 50%;
  }
}


</style>
